import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, createVariableCategoryValues } from 'store/data/variables';

type HandlerInput = Parameters<typeof createVariableCategoryValues>[0];

export function useCreateVariableCategoryValues(): Operation<(input: HandlerInput) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(
		ActionTypes.CREATE_VARIABLE_CATEGORY_VALUES
	);

	function handler(input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		dispatch(createVariableCategoryValues(input));
	}

	return [{ loading, error }, handler];
}
